import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/movies";
import SectionHeading from "@/components/feature/SectionHeading";

const picks = [...mediaList].sort((a, b) => b.hot - a.hot).slice(0, 8);

export default function HotRecommend() {
  return (
    <section className="w-full bg-background-100 px-4 md:px-8 py-10 md:py-14" aria-label="热门推荐">
      <SectionHeading
        eyebrow="编辑精选"
        title="热门推荐"
        desc="由编辑团队结合口碑与热度精心挑选，帮你告别选择困难。"
        moreTo="/category/tv"
        moreLabel="进入剧集"
      />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {picks.map((item, i) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-300 hover:-translate-y-0.5 cursor-pointer"
          >
            <span
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                i < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
              }`}
            >
              {i + 1}
            </span>
            <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={item.poster}
                alt={`${item.title} 海报`}
                title={`${item.title} - 蘑菇视频热门推荐`}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1 truncate text-xs text-foreground-500">{item.genre} · {item.region} · {item.year}</p>
              <p className="mt-1.5 line-clamp-1 text-xs text-foreground-400">{item.actors.slice(0, 2).join("、")} 主演</p>
            </div>
            <div className="hidden shrink-0 flex-col items-end gap-1 sm:flex">
              <span className="flex items-center gap-1 text-sm font-bold text-primary-600">
                <i className="ri-star-fill text-xs" aria-hidden="true"></i>
                {item.rating.toFixed(1)}
              </span>
              <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800">{item.type}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}